<div *transloco="let t" class="flex flex-col h-full">

  <!-- Header -->
  <div class="flex items-center justify-between px-8 h-[72px] border-b border-gray-100 shrink-0">
    <div class="flex items-center gap-3">
      <button *ngIf="currentStep === 2"
              class="flex items-center justify-center w-9 h-9 rounded-xl hover:bg-gray-100 transition-colors duration-150 cursor-pointer"
              (click)="goBack()">
        <mat-icon class="!w-5 !h-5 !text-[20px] !leading-5 text-gray-500">arrow_back</mat-icon>
      </button>
      <h2 class="text-lg font-semibold tracking-tight text-gray-800 m-0">
        {{ t(getStepTitle()) }}
      </h2>
    </div>
    <button mat-dialog-close
            class="flex items-center justify-center w-10 h-10 rounded-xl hover:bg-gray-100 transition-colors duration-150 cursor-pointer">
      <mat-icon class="!w-5 !h-5 !text-[20px] !leading-5 text-gray-400">close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <div class="px-6 py-5 bg-gray-50 bg-opacity-50 overflow-y-auto" style="max-height: 400px;">

    <!-- Loading spinner -->
    <div *ngIf="loading" class="flex justify-center py-12">
      <mat-progress-spinner
        [diameter]="48"
        [mode]="'indeterminate'">
      </mat-progress-spinner>
    </div>

    <!-- Error message -->
    <div *ngIf="errorMessage && !loading" class="mb-4 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-2xl">
      <p class="text-red-600 dark:text-red-400 text-sm m-0">
        {{ t(errorMessage) }}
      </p>
    </div>

    <!-- BROKER: Profile list (single step) -->
    <div *ngIf="!loading && entityType === 'BROKER_POINT_OF_SALE'" class="space-y-3">
      <div
        *ngFor="let profile of brokerOptions"
        class="group p-4 rounded-2xl bg-white border border-gray-100 cursor-pointer hover:border-primary-300 hover:shadow-lg hover:shadow-primary-100/50 transition-all duration-150"
        (click)="selectBrokerProfile(profile)">
        <div class="flex items-center justify-between gap-4">
          <div class="flex-shrink-0 w-11 h-11 rounded-xl overflow-hidden bg-gray-50 flex items-center justify-center">
            <img
              [src]="profile.companyLogo || 'assets/images/logo/logo.png'"
              [alt]="profile.profileName"
              class="w-full h-full object-contain p-1">
          </div>
          <div class="flex-1 min-w-0">
            <div class="text-[15px] font-semibold text-gray-700 group-hover:text-primary-700 truncate">
              {{ t('enums.entity_types.' + profile.profileName) }}
            </div>
            <div class="text-sm text-gray-400 truncate">
              {{ profile.companyName }}
            </div>
          </div>
          <mat-icon class="flex-shrink-0 text-gray-300 group-hover:text-primary-400 icon-size-5" [svgIcon]="'heroicons_outline:chevron-right'"></mat-icon>
        </div>
      </div>
    </div>

    <!-- CONTRIBUTOR / SUB_CONTRIBUTOR: Step 1 options -->
    <div *ngIf="!loading && (entityType === 'CONTRIBUTOR' || entityType === 'SUB_CONTRIBUTOR') && currentStep === 1" class="space-y-3">
      <div
        *ngFor="let option of twoStepOptions"
        class="group p-4 rounded-2xl bg-white border border-gray-100 cursor-pointer hover:border-primary-300 hover:shadow-lg hover:shadow-primary-100/50 transition-all duration-150"
        (click)="selectStep1Option(option)">
        <div class="flex items-center justify-between gap-4">
          <div class="flex-shrink-0 w-11 h-11 rounded-xl overflow-hidden bg-gray-50 flex items-center justify-center">
            <img
              [src]="option.logo || 'assets/images/logo/logo.png'"
              [alt]="option.optionName"
              class="w-full h-full object-contain p-1">
          </div>
          <div class="flex-1 min-w-0">
            <div class="text-[15px] font-semibold text-gray-700 group-hover:text-primary-700 truncate">
              {{ option.optionName }}
            </div>
            <div class="text-sm text-gray-400 truncate">
              {{ option.parentEntityName || t('enums.entity_types.' + option.optionType) }}
            </div>
          </div>
          <mat-icon class="flex-shrink-0 text-gray-300 group-hover:text-primary-400 icon-size-5" [svgIcon]="'heroicons_outline:chevron-right'"></mat-icon>
        </div>
      </div>
    </div>

    <!-- CONTRIBUTOR / SUB_CONTRIBUTOR: Step 2 (POS selection) -->
    <div *ngIf="!loading && (entityType === 'CONTRIBUTOR' || entityType === 'SUB_CONTRIBUTOR') && currentStep === 2" class="space-y-3">
      <div
        *ngFor="let option of posOptions"
        class="group p-4 rounded-2xl bg-white border border-gray-100 cursor-pointer hover:border-primary-300 hover:shadow-lg hover:shadow-primary-100/50 transition-all duration-150"
        (click)="selectStep2Option(option)">
        <div class="flex items-center justify-between gap-4">
          <div class="flex-shrink-0 w-11 h-11 rounded-xl overflow-hidden bg-gray-50 flex items-center justify-center">
            <img
              [src]="option.logo || 'assets/images/logo/logo.png'"
              [alt]="option.optionName"
              class="w-full h-full object-contain p-1">
          </div>
          <div class="flex-1 min-w-0">
            <div class="text-[15px] font-semibold text-gray-700 group-hover:text-primary-700 truncate">
              {{ option.optionName }}
            </div>
            <div class="text-sm text-gray-400 truncate">
              {{ option.parentEntityName || t('enums.entity_types.' + option.optionType) }}
            </div>
          </div>
          <mat-icon class="flex-shrink-0 text-gray-300 group-hover:text-primary-400 icon-size-5" [svgIcon]="'heroicons_outline:chevron-right'"></mat-icon>
        </div>
      </div>
    </div>

    <!-- No options -->
    <div *ngIf="!loading && !errorMessage && getVisibleOptions().length === 0" class="text-center text-gray-400 py-12">
      {{ t('user.switch_profile.no_options') }}
    </div>
  </div>
</div>
